export * from './dialog-yes.component';



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/dialog-yes/index.ts